export const KEYWORD_OPTIONS = ['어버이날', '가정의달', '어린이날'] as const;
export type Keyword = (typeof KEYWORD_OPTIONS)[number];

export const KEYWORD_CHART_DATA: Record<Keyword, { date: string; 언급량: number }[]> = {
  어버이날: [
    { date: '05/01', 언급량: 30 },
    { date: '05/02', 언급량: 28 },
    { date: '05/03', 언급량: 22 },
    { date: '05/04', 언급량: 28 },
    { date: '05/05', 언급량: 27 },
    { date: '05/06', 언급량: 25 },
    { date: '05/07', 언급량: 25 },
    { date: '05/08', 언급량: 25 },
  ],
  가정의달: [
    { date: '05/01', 언급량: 20 },
    { date: '05/02', 언급량: 22 },
    { date: '05/03', 언급량: 19 },
    { date: '05/04', 언급량: 26 },
    { date: '05/05', 언급량: 29 },
    { date: '05/06', 언급량: 21 },
    { date: '05/07', 언급량: 28 },
    { date: '05/08', 언급량: 30 },
  ],
  어린이날: [
    { date: '05/01', 언급량: 20 },
    { date: '05/02', 언급량: 21 },
    { date: '05/03', 언급량: 24 },
    { date: '05/04', 언급량: 28 },
    { date: '05/05', 언급량: 30 },
    { date: '05/06', 언급량: 28 },
    { date: '05/07', 언급량: 21 },
    { date: '05/08', 언급량: 20 },
  ],
};
